import {Layout, Menu, MenuProps} from 'antd';
import {Navigate, NavLink, Route, Routes, useLocation} from 'react-router-dom';
import {useAppSelector} from '../../../common/hooks';
import Employees from './employees/Employees';
import Roles from './roles/Roles';
type MenuItem = Required<MenuProps>['items'][number];

const {Header, Content} = Layout;

const Main = () => {
  const userPermission = useAppSelector((state) => state.config.config.permissions);

  const items: MenuItem[] = [
    userPermission.show_employee
      ? {label: <NavLink to={'/setup/employee/employees'}>Employees</NavLink>, key: 'employees'}
      : null,
    userPermission.show_permissiongroup
      ? {label: <NavLink to={'/setup/employee/roles'}>Roles</NavLink>, key: 'roles'}
      : null,
  ];

  return (
    <Layout style={{height: '100%', backgroundColor: '#fff'}}>
      <Header
        style={{
          backgroundColor: '#fff',
          alignItems: 'center',
          paddingInline: '00px',
          height: '48px',
          marginBottom: '10px',
          borderBottom: ' 1px solid #00000022',
        }}
      >
        <Menu
          mode='horizontal'
          theme='light'
          // defaultSelectedKeys={['roles']}
          selectedKeys={[useLocation().pathname.split('/')[3]]}
          style={{
            backgroundColor: 'transparent',
            border: '0px',
            lineHeight: '40px',
          }}
          items={items}
        />
      </Header>
      <Content>
        <Routes>
          {userPermission.show_permissiongroup && <Route path='/roles' element={<Roles />} />}
          <Route path='/' element={userPermission.show_employee && <Navigate to={'employees'} />} />
          {userPermission.show_employee && <Route path='/employees' element={<Employees />} />}
          <Route path='/*' element={<Navigate to={'/404/'} />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default Main;
